/*
 * Logo hover spin controller.
 *
 * The decorative mark spins while the logo is hovered. Instead of stopping
 * the CSS animation the instant the cursor leaves (which snaps the mark back
 * to its start position), we let the current turn finish: on mouse-leave we
 * flag the logo, and remove the animation only at the next `animationiteration`
 * boundary — the exact moment the mark is back at its resting position, so the
 * stop is seamless (no jump).
 *
 * Uses event delegation so dynamically-added logos (e.g. a sticky header that
 * is cloned on scroll) are handled automatically. Disabled entirely when the
 * visitor prefers reduced motion.
 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var HOVER_TARGET = '.logo, .logo-block'; // header logo anchor + footer logo block
  var ACTIVE_CLASS = 'cb-spin';
  var DOT_SELECTOR = '.cb-logo-svg svg path[fill="#7F368A" i]';

  // Attach the iteration listener once per logo, to every decorative path it
  // contains (default + inverse copies). Only the visible one actually fires.
  function bind(logo) {
    if (logo._cbSpinBound) return;
    logo._cbSpinBound = true;

    var dots = logo.querySelectorAll(DOT_SELECTOR);
    for (var i = 0; i < dots.length; i++) {
      dots[i].addEventListener('animationiteration', function () {
        if (logo.getAttribute('data-cb-stop') === '1') {
          logo.classList.remove(ACTIVE_CLASS);
          logo.setAttribute('data-cb-stop', '0');
        }
      });
    }
  }

  document.addEventListener('mouseover', function (e) {
    var logo = e.target && e.target.closest ? e.target.closest(HOVER_TARGET) : null;
    if (!logo || !logo.querySelector('.cb-logo-svg')) return;
    bind(logo);
    logo.setAttribute('data-cb-stop', '0'); // cancel any pending stop
    logo.classList.add(ACTIVE_CLASS);
  });

  document.addEventListener('mouseout', function (e) {
    var logo = e.target && e.target.closest ? e.target.closest(HOVER_TARGET) : null;
    if (!logo) return;
    // Ignore moves between children that stay inside the logo.
    if (e.relatedTarget && logo.contains(e.relatedTarget)) return;
    if (logo.classList.contains(ACTIVE_CLASS)) {
      logo.setAttribute('data-cb-stop', '1'); // finish the current turn, then stop
    }
  });
})();
